import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function withdrawalManagerList(data) { return axios.post(`${base.url}/payment/withdrawalManager/list`, qs.stringify(data)) }
export function withdrawalManagerStats(data) { return axios.post(`${base.url}/payment/withdrawalManager/stats`, qs.stringify(data)) }
export function withdrawalManagerReviewStatusCounts(data) { return axios.post(`${base.url}/payment/withdrawalManager/reviewStatusCounts`, qs.stringify(data)) }
export function withdrawalManagerBatchReview(ids, reviewStatus) { return axios.post(`${base.url}/payment/withdrawalManager/batchReview`, qs.stringify({ ids, reviewStatus })) }
export function withdrawalManagerExport(data) { return axios.post(`${base.url}/payment/withdrawalManager/export`, qs.stringify(data), { responseType: 'blob' }) }
